var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-btn flexrowcenter",on:{"click":_vm.onClick}},[_c('div',{staticClass:"btn flexrowcenter"},[_vm._v(" "+_vm._s(_vm.title || "确定")+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }